﻿/* eslint-disable no-inner-declarations */
import { utils, DOMSanitization } from '../../../Foundation';

export function buildSummary() {
  let debugFunction = false;

  let consoleInfo = 'background: #ECBE13; color: #fff; padding: 4px 10px;';
  let consoleParentTrue =
    'background: #77AB59; color: #fff; padding: 4px 10px;border-left:40px solid white;';
  let consoleChildTrue =
    'background: #77AB59; color: #fff; padding: 4px 10px;border-left:60px solid white;';
  let consoleParentFalse =
    'background: #E35B5D; color: #fff; padding: 4px 10px;border-left:40px solid white;';

  if (debugFunction) {
    console.log('%c _buildSummary() Called ', consoleInfo);
  }

  // This function is to build up the content seen in the Configuration Summary (on the left)
  // It is broken down into question specific code as each question has different markup / structure so its difficult to reuse / repeat
  // We start by checking if the question exists
  //      If it does we alter the CSS for that specific questions Configuration Summary section so that it shows
  //          By default the Configuration Summary sections are hidden
  // Some data is available on page load
  // Some data is available via a user interaction, clicking on a color for example
  // Once the data is found, either on page load or interaction we write this information to its specific area in the Configuration Summary

  // ***************
  // Color
  // ***************
  let checkColor = document.querySelector('[id*="SelectedColorItemIdHiddenField"]');
  if (typeof checkColor != 'undefined' && checkColor != null) {
    if (debugFunction) {
      console.log('%c Color ', consoleParentTrue);
    }
    // Pageload
    let colorValue = document.getElementById('SelectedColorItemTextHiddenField')
      ? document.getElementById('SelectedColorItemTextHiddenField').value
      : null;
    // If the question is not empty
    if (colorValue != '') {
      // Write to summary
      document.querySelector('.configurator_summary__list-color').classList.remove('is-hidden');
      document.querySelector('.configurator_summary__list-color .value').innerHTML =
        utils.toTitleCase(colorValue);
    } else {
      let colorFirst = document
        .querySelector('color-dropdown .color_select')
        .selectedOptions[0].getAttribute('data-label');
      // Write to summary
      document.querySelector('.configurator_summary__list-color').classList.remove('is-hidden');
      document.querySelector('.configurator_summary__list-color .value').innerHTML =
        utils.toTitleCase(colorFirst);
    }
  } else {
    if (debugFunction) {
      console.log('%c Color ', consoleParentFalse);
    }
  }

  // ***************
  // Ear side order
  // ***************
  function switchSides() {
    const sideLeft = document.querySelector('.configurator__selector__side--left').parentNode;
    const sideRight = document.querySelector('.configurator__selector__side--right').parentNode;
    sides.insertBefore(sideRight, sideLeft);
    sides.classList.add('is--visible');
  }

  const sides = document.querySelector('.is-side-selection');
  if (sides) {
    switchSides();
  }

  // ***************
  // Order type
  // ***************
  let checkOrderType = document.querySelector(
    '[id*="ConfigurePatientInfo_IsPatientInfoOptionalHiddenField"]',
  );
  if (typeof checkOrderType != 'undefined' && checkOrderType != null) {
    document.querySelector('.configurator_summary__list-order-type').classList.remove('is-hidden');
    if (debugFunction) {
      console.log('%c Order type ', consoleParentTrue);
    }
    // Pageload
    let orderType = document.querySelector('#configure__ordertypeandquatiantity .is-order-type');
    let orderTypeValue = '';
    let side = document.querySelector('#configure__ordertypeandquatiantity .is-side-selection');
    let sideValue = '';
    let orderTypeStockIncrease = '';
    let orderTypeStockDecrease = '';
    let orderTypeStockValue = '';

    // If the question exists and has a value
    if (typeof orderType != 'undefined' && orderType != null) {
      // Assign its value to the variable
      const selectedOrderType = document.querySelector(
        '#configure__ordertypeandquatiantity .is-order-type input:checked',
      );
      const selectedOrderTypeLabel = document.querySelector(
        '#configure__ordertypeandquatiantity .is-order-type input:checked ~ label',
      );
      orderTypeValue = document.querySelector(
        '#configure__ordertypeandquatiantity .is-order-type input',
      )
        ? selectedOrderTypeLabel.innerText
        : selectedOrderType.value;
      let orderTypeValueHiddenInput = document.querySelector(
        '[id*="OrderTypeAndQuantity_InitialSelectedOrderType"]',
      )
        ? document.querySelector('[id*="OrderTypeAndQuantity_InitialSelectedOrderType"]').value
        : null;
      // Write to summary
      document.querySelector('.configurator_summary__list .value-type').innerHTML = orderTypeValue;
      // If the value is 'Stock'
      // Else we hide it again
      if (orderTypeValueHiddenInput === 'Stock' || orderTypeValueHiddenInput === 'Consignment') {
        // Get the - and + butons
        orderTypeStockIncrease = document.querySelector(
          '#configure__ordertypeandquatiantity .number-input .number-input__button--plus',
        );
        orderTypeStockDecrease = document.querySelector(
          '#configure__ordertypeandquatiantity .number-input .number-input__button--minus',
        );
        // Show the Configuration Summary area for this specific question
        // Assign its value to the variable
        orderTypeStockValue = document.querySelector(
          '#configure__ordertypeandquatiantity .number-input input',
        ).value;
        // Write to summary
        document.querySelector(
          '.configurator_summary__list-order-type .value-list-stock-amount',
        ).innerHTML = ', ' + orderTypeStockValue;
        // Interaction
        // If the user clicks the +
        // Update the stock value in the Configuration Summary
        orderTypeStockIncrease.addEventListener('click', () => {
          orderTypeStockValue = document.querySelector(
            '#configure__ordertypeandquatiantity .number-input input',
          ).value;
          // Write to summary
          document
            .querySelector('#configure__ordertypeandquatiantity .number-input input')
            .addEventListener('change', () => {
              orderTypeStockValue = document.querySelector(
                '#configure__ordertypeandquatiantity .number-input input',
              ).value;
              // Write to summary
              document.querySelector(
                '.configurator_summary__list-order-type .value-list-stock-amount',
              ).innerHTML = ', ' + Number(orderTypeStockValue);
            });
        });
        document
          .querySelector('#configure__ordertypeandquatiantity .number-input input')
          .addEventListener('input', () => {
            orderTypeStockValue = document.querySelector(
              '#configure__ordertypeandquatiantity .number-input input',
            ).value;
            // Write to summary
            orderTypeStockValue = document.querySelector(
              '#configure__ordertypeandquatiantity .number-input input',
            ).value;
            // Write to summary
            document.querySelector(
              '.configurator_summary__list-order-type .value-list-stock-amount',
            ).innerHTML = ', ' + Number(orderTypeStockValue);
            document
              .querySelector('#configure__ordertypeandquatiantity .number-input input')
              .addEventListener('change', () => {
                orderTypeStockValue = document.querySelector(
                  '#configure__ordertypeandquatiantity .number-input input',
                ).value;
                // Write to summary
                orderTypeStockValue = document.querySelector(
                  '#configure__ordertypeandquatiantity .number-input input',
                ).value;
                // Write to summary
                document.querySelector(
                  '.configurator_summary__list-order-type .value-list-stock-amount',
                ).innerHTML = ', ' + Number(orderTypeStockValue);
              });
          });
        // If the user clicks the -
        // And the button isnt disabled
        // Update the stock value in the Configuration Summary
        orderTypeStockDecrease.addEventListener('click', () => {
          orderTypeStockValue = document.querySelector(
            '#configure__ordertypeandquatiantity .number-input input',
          ).value;
          // Write to summary
          document.querySelector(
            '.configurator_summary__list-order-type .value-list-stock-amount',
          ).innerHTML = ', ' + Number(orderTypeStockValue);
          document
            .querySelector('#configure__ordertypeandquatiantity .number-input input')
            .addEventListener('change', () => {
              orderTypeStockValue = document.querySelector(
                '#configure__ordertypeandquatiantity .number-input input',
              ).value;
              // Write to summary
              document.querySelector(
                '.configurator_summary__list-order-type .value-list-stock-amount',
              ).innerHTML = ', ' + Number(orderTypeStockValue);
            });
        });

        let checkPackaging = document.querySelector('#configure__packaging');
        if (typeof checkPackaging != 'undefined' && checkPackaging != null) {
          if (debugFunction) {
            console.log('%c Packaging ', consoleParentTrue);
          }

          let packaging = document.querySelector(
            '#configure__packaging [id*="ConfigurePackaging_PackagingCheckBoxList"]',
          );
          // Page load
          if (packaging.querySelector('input').checked) {
            // Write to summary
            document
              .querySelector('.configurator_summary__list-packaging')
              .classList.remove('is-hidden');
            document.querySelector('.configurator_summary__list-packaging .value').innerHTML =
              packaging.querySelector('input').value;
          } else {
            // Write to summary
            document
              .querySelector('.configurator_summary__list-packaging')
              .classList.add('is-hidden');
            document.querySelector('.configurator_summary__list-packaging .value').innerHTML = '';
          }
          // Interaction
          packaging.querySelector('label').addEventListener('click', () => {
            packaging.addEventListener('change', () => {
              if (packaging.querySelector('input').checked) {
                // Write to summary
                document
                  .querySelector('.configurator_summary__list-packaging')
                  .classList.remove('is-hidden');
                document.querySelector('.configurator_summary__list-packaging .value').innerHTML =
                  packaging.querySelector('input').value;
              } else {
                // Write to summary
                document
                  .querySelector('.configurator_summary__list-packaging')
                  .classList.add('is-hidden');
                document.querySelector('.configurator_summary__list-packaging .value').innerHTML =
                  '';
              }
            });
          });
        }
      } else {
        document.querySelector('.configurator_summary__list-packaging').classList.add('is-hidden');
      }
    }
    // If the question exists and has a value
    if (typeof side != 'undefined' && side != null) {
      // Assign its value to the variable
      const selectedSideSelection = document.querySelector(
        '#configure__ordertypeandquatiantity .is-side-selection input:checked',
      );
      const selectedSideSelectionLabel = document.querySelector(
        '#configure__ordertypeandquatiantity .is-side-selection input:checked ~ label',
      );
      sideValue = document.querySelector(
        '#configure__ordertypeandquatiantity .is-side-selection input',
      )
        ? selectedSideSelectionLabel?.innerText
        : selectedSideSelection?.value;
      // Write to summary
      document.querySelector('.configurator_summary__list .value-side').innerHTML =
        ', ' + sideValue;
      // Depending on the side we need to hide other questions Summary areas
      if (sideValue === 'Left') {
        document
          .querySelector('.configurator_summary__list-receiver .value-right')
          .classList.add('is-hidden');
        document
          .querySelector('.configurator_summary__list-tube .value-right')
          .classList.add('is-hidden');
      } else if (sideValue === 'Right') {
        document
          .querySelector('.configurator_summary__list-receiver .value-left')
          .classList.add('is-hidden');
        document
          .querySelector('.configurator_summary__list-tube .value-left')
          .classList.add('is-hidden');
      } else {
        document
          .querySelector('.configurator_summary__list-receiver .value-left')
          .classList.remove('is-hidden');
        document
          .querySelector('.configurator_summary__list-receiver .value-right')
          .classList.remove('is-hidden');
        document
          .querySelector('.configurator_summary__list-tube .value-left')
          .classList.remove('is-hidden');
        document
          .querySelector('.configurator_summary__list-tube .value-right')
          .classList.remove('is-hidden');
      }
    }
  } else {
    if (debugFunction) {
      console.log('%c Order type ', consoleParentFalse);
    }
  }

  // ***************
  // Name
  // ***************
  let checkName = document.querySelector('.configurePatientInfo');
  // Question can be hidden rather than not renderred
  let checkNameDisplay = window.getComputedStyle(checkName).display;
  if (typeof checkName != 'undefined' && checkName != null && checkNameDisplay != 'none') {
    if (debugFunction) {
      console.log('%c Name ', consoleParentTrue);
    }

    // Pageload
    let firstName = document.querySelector('[id*="PatientFirstNameTextBox"]');
    let firstNameValue = '';
    let surName = document.querySelector('[id*="PatientLastNameTextBox"]');
    let surNameValue = '';

    // To show or hide summary section
    function showSummary() {
      if (firstNameValue !== '' || surNameValue !== '') {
        document.querySelector('.configurator_summary__list-name').classList.remove('is-hidden');
      } else {
        document.querySelector('.configurator_summary__list-name').classList.add('is-hidden');
      }
    }

    // If the question exists and has a value
    if (typeof firstName != 'undefined' && firstName != null && firstName.value !== '') {
      // Assign its value to the variable
      firstNameValue = firstName.value;
      // Write to summary
      showSummary();
      document.querySelector('.configurator_summary__list-name .value-first').innerHTML =
        firstNameValue + ' ';
    } else {
      document.querySelector('.configurator_summary__list-name').classList.add('is-hidden');
    }
    // If the question exists and has a value
    if (typeof surName != 'undefined' && surName != null && firstName && firstName.value !== '') {
      // Assign its value to the variable
      surNameValue = surName.value;
      // Write to summary
      showSummary();
      document.querySelector('.configurator_summary__list-name .value-second').innerHTML =
        surNameValue;
    } else {
      document.querySelector('.configurator_summary__list-name').classList.add('is-hidden');
    }
    // Interaction
    // If the user types their name
    if (typeof firstName != 'undefined' && firstName != null) {
      firstName.addEventListener('focusout', () => {
        // Assign its value to the variable
        firstNameValue = firstName.value;
        // Write to summary
        showSummary();
        document.querySelector('.configurator_summary__list-name .value-first').innerHTML =
          firstNameValue + ' ';
      });
    } else {
      document.querySelector('.configurator_summary__list-name').classList.add('is-hidden');
    }
    // If the user types their name
    if (typeof surName != 'undefined' && surName != null) {
      surName.addEventListener('focusout', () => {
        // Assign its value to the variable
        surNameValue = surName.value;
        // Write to summary
        showSummary();
        document.querySelector(
          '.configurator_summary__list-name .value-second',
        ).innerHTML = `&nbsp;${surNameValue}`;
      });
    } else {
      document.querySelector('.configurator_summary__list-name').classList.add('is-hidden');
    }
  } else {
    if (debugFunction) {
      console.log('%c Name ', consoleParentFalse);
    }
  }

  // ***************
  // Charger
  // Bundled or Unbundled
  // ***************
  let checkCharger = document.querySelector('[id*="ConfigureAccessoriesChargers"]');
  if (typeof checkCharger != 'undefined' && checkCharger != null) {
    if (debugFunction) {
      console.log('%c Charger ', consoleParentTrue);
    }
    let charger = $('[id*="ConfigureAccessoriesChargers"] input:checkbox');
    let chargerValue = [];
    let chargersHTMLElements = [];

    // To show or hide summary section
    function showSummary() {
      if (chargerValue.length >= 1) {
        document.querySelector('.configurator_summary__list-charger').classList.remove('is-hidden');
      } else {
        document.querySelector('.configurator_summary__list-charger').classList.add('is-hidden');
      }
    }

    // Check if bundled or unbundled
    // If the checkboxes have length we are bundled
    if (charger.length > 0) {
      if (debugFunction) {
        console.log('%c Charger UnBundled ', consoleChildTrue);
      }
      //Page load
      let chargerAll = document.querySelectorAll(
        '[id*="ConfigureAccessoriesChargers"] input.configurator__accessory-checkbox:checked',
      );

      chargerAll.forEach((charger) => {
        let chargerSelected = charger
          .closest('.configurator__accessories-item')
          .querySelector('.configurator__accessory-title').textContent;

        // Check if charger array contains the item we just selected
        // If it does remove it from the array
        // Else push it to the array
        if (chargerValue.indexOf(chargerSelected) > -1) {
          chargerValue.splice(chargerValue.indexOf(chargerSelected), 1);
        } else {
          chargerValue.push(chargerSelected);
        }
        let chargerValueHTML = '';
        for (let charger of chargerValue) {
          chargerValueHTML += `<span>${charger.split(',').join(', ')}</span>`;
        }
        // Write to summary
        showSummary();
        document.querySelector('.configurator_summary__list-charger .value').innerHTML =
          chargerValueHTML;
      });

      // Interaction
      // If the user chooses a charger
      charger.change(function () {
        let chargerSelectedTitle = this.closest('.configurator__accessories-item').querySelector(
          '.configurator__accessory-title',
        ).textContent;
        let chargerSelectedInput = this.closest('.configurator__accessories-item').querySelector(
          'input[type="checkbox"].configurator__accessory-checkbox',
        );
        // Check if charger array contains the item we just selected
        // If it does remove it from the array
        // Else push it to the array

        //IF THERE IS ALREADY CHARGER INSIDE, UNCHECK PREVIOUS AND CHECK ACTUAL
        if (chargerValue.indexOf(chargerSelectedTitle) > -1) {
          chargerValue.splice(chargerValue.indexOf(chargerSelectedTitle), 1);
          chargerSelectedInput.checked = false;
          chargersHTMLElements = [];
        } else if (chargerValue.length > 0) {
          chargersHTMLElements.forEach((c) => (c.checked = false));
          chargerValue = [];
          chargersHTMLElements = [];
          chargerValue.push(chargerSelectedTitle);
          chargersHTMLElements.push(chargerSelectedInput);
          chargerSelectedInput.checked = true;
        } else {
          chargerValue.push(chargerSelectedTitle);
          chargersHTMLElements.push(chargerSelectedInput);
          chargerSelectedInput.checked = true;
        }

        let chargerValueHTML = '';
        for (let charger of chargerValue) {
          chargerValueHTML += `<span>${charger.split(',').join(', ')}</span>`;
        }
        // Write to summary
        showSummary();
        document.querySelector('.configurator_summary__list-charger .value').innerHTML =
          chargerValueHTML;
      });
    } else {
      if (debugFunction) {
        console.log('%c Charger Bundled ', consoleChildTrue);
      }
      function getData() {
        // Find all Charger containers
        let chargerAll = document.querySelectorAll(
          '[id*="ConfigureAccessoriesChargers"] .configurator__accessories-item',
        );
        // Loop of them and push the text and quantity to the array
        chargerAll.forEach((charger) => {
          let chargerValueText = charger.querySelector('.configurator__accessory-title').innerText;
          let chargerValueQuantity = charger.querySelector('.number-input__field').value;
          if (chargerValueQuantity > 0) {
            chargerValue.push([chargerValueText.split(',').join(', '), chargerValueQuantity]);
          }
          charger.querySelector('.number-input__field').addEventListener('input', () => {
            chargerValue = [];
            getData();
          });
        });
        let chargerValueHTML = '';
        for (let charger of chargerValue) {
          chargerValueHTML += `<span>${charger[1]} x ${charger[0]}</span>`;
        }
        // Write to summary
        showSummary();
        document.querySelector('.configurator_summary__list-charger .value').innerHTML =
          chargerValueHTML;
      }
      // Page load
      getData();
      // Interaction
      $(document).on(
        'click',
        '[id*="ConfigureAccessoriesChargers"] .number-input__button--minus, [id*="ConfigureAccessoriesChargers"] .number-input__button--plus',
        function () {
          // Reset array so we dont need to search for duplicates
          chargerValue = [];
          getData();
        },
      );
    }
  } else {
    if (debugFunction) {
      console.log('%c Charger ', consoleParentFalse);
    }
  }

  // ***************
  // Receiver
  // Start by checking if the question exists
  // Check if we are seeing Bundled or Unbundled
  // Get values on Page Load
  //      If nothing selected dont add to Summary
  //      If values selected add to Summary
  // Get values on Page Refresh (change color for example)
  //      If nothing selected dont add to Summary
  //      If values selected add to Summary
  //          Check if HTML has been updated as data is grabbed in different way
  // Get values on Side change (left vs right)
  //      If nothing selected dont add to Summary
  //      If values selected add to Summary
  //          Check if HTML has been updated as data is grabbed in different way
  // Get values on question interaction
  //      If nothing selected dont add to Summary
  //      If values selected add to Summary
  //          Check if HTML has been updated as data is grabbed in different way
  // ***************
  let checkReceiver = document.querySelector(
    '[id*="ConfigureAccessoriesRecievers_ShowAccessories_AccessoriesPanel"]',
  );
  if (typeof checkReceiver != 'undefined' && checkReceiver != null) {
    if (debugFunction) {
      console.log('%c Receiver ', consoleParentTrue);
    }

    // Get the value for the sides as these can be translated but we need the values
    let sideTranslations = checkReceiver
      .closest('.configurator__accessories')
      .querySelectorAll('.configurator__accessories-content_item');
    let leftTranslation = sideTranslations[0]?.getAttribute('data-item');
    let rightTranslation = sideTranslations[1]?.getAttribute('data-item');

    let receiverBundleCheck = checkReceiver
      .closest('.configurator__accessories')
      .querySelectorAll('product-dropdown .number-input__field');
    let leftValue = [];
    let rightValue = [];

    // To show or hide summary section
    function showSummary() {
      if (leftValue.length >= 1 || rightValue.length >= 1) {
        document
          .querySelector('.configurator_summary__list-receiver')
          .classList.remove('is-hidden');
      } else {
        document.querySelector('.configurator_summary__list-receiver').classList.add('is-hidden');
      }
    }

    // Check if bundled or unbundled
    // If the quantity have length we are bundled
    if (receiverBundleCheck.length > 0) {
      if (debugFunction) {
        console.log('%c Receiver UnBundled ', consoleChildTrue);
      }
      function getDataBoth(side) {
        // Find all items
        let items = checkReceiver
          .closest('.configurator__accessories')
          .querySelectorAll('product-dropdown .item_' + side + ' .configurator__accessories-item');
        // Loop of them and push the text and quantity to the array
        items.forEach((item) => {
          let itemSelect = item.querySelector('.form-select select');
          let itemSelectIndex = itemSelect.options[itemSelect.selectedIndex].index;
          let itemSelectText = itemSelect.options[itemSelect.selectedIndex].text;
          let itemValueQuantity = item.querySelector('.number-input__field').value;
          // If select menu isnt first item
          if (itemSelectIndex === 0) {
            // Dont push data
          } else {
            if (itemValueQuantity > 0) {
              if (side === leftTranslation) {
                leftValue.push([itemSelectText.split(',').join(', '), itemValueQuantity]);
              } else if (side === rightTranslation) {
                rightValue.push([itemSelectText.split(',').join(', '), itemValueQuantity]);
              }
            }
          }
        });
        let itemValueHTML = '';
        if (side === leftTranslation) {
          for (let item of leftValue) {
            itemValueHTML += `<span>${item[1]} x ${item[0]}</span>`;
          }
          // Write to summary
          showSummary();
          document.querySelector('.configurator_summary__list-receiver .value-left').innerHTML =
            itemValueHTML;
        } else if (side === rightTranslation) {
          for (let item of rightValue) {
            itemValueHTML += `<span>${item[1]} x ${item[0]}</span>`;
          }
          // Write to summary
          showSummary();
          document.querySelector('.configurator_summary__list-receiver .value-right').innerHTML =
            itemValueHTML;
        }
      }

      // Page load
      getDataBoth(leftTranslation);
      getDataBoth(rightTranslation);

      // Interaction
      // If a user chooses a side item
      $(checkReceiver.closest('section')).on(
        'click',
        'product-dropdown .form-select__list-item, product-dropdown .number-input__button--plus, product-dropdown .number-input__button--minus',
        function () {
          // Reset array so we dont need to search for duplicates
          leftValue = [];
          getDataBoth(leftTranslation);
          // Reset array so we dont need to search for duplicates
          rightValue = [];
          getDataBoth(rightTranslation);
        },
      );

      $(checkReceiver.closest('section')).on('input', '.number-input__field', function () {
        // Reset array so we dont need to search for duplicates
        leftValue = [];
        getDataBoth(leftTranslation);
        // Reset array so we dont need to search for duplicates
        rightValue = [];
        getDataBoth(rightTranslation);
      });
    } else {
      if (debugFunction) {
        console.log('%c Receiver Bundled ', consoleChildTrue);
      }
      // On page we load we have different html we need to run the IF = select side against
      // Once we click on Stock or Color we are passed different HTML but we still need to run the same if against it
      // on page load if html has more html with nested span assign that inner text to var, else target default html and assign that innertext to var
      // Basically the check is are we seeing just '.form-select__placeholder' or '.form-select__placeholder > .form-select__list-label'

      // Page load
      let receiverLeftReadySelect = checkReceiver
        .closest('.configurator__accessories')
        .querySelector('product-dropdown .item_' + leftTranslation + ' select');
      let receiverLeftReadySelectIndex =
        receiverLeftReadySelect?.options[receiverLeftReadySelect.selectedIndex].index ?? 0;
      let receiverLeftReadySelectText =
        receiverLeftReadySelect?.options[receiverLeftReadySelect.selectedIndex].text ?? '';

      let receiverRightReadySelect = checkReceiver
        .closest('.configurator__accessories')
        .querySelector('product-dropdown .item_' + rightTranslation + ' select');
      let receiverRightReadySelectIndex =
        receiverRightReadySelect?.options[receiverRightReadySelect.selectedIndex].index ?? 0;
      let receiverRightReadySelectText =
        receiverRightReadySelect?.options[receiverRightReadySelect.selectedIndex].text ?? '';

      // Left
      // If select menu isnt first item
      if (receiverLeftReadySelectIndex === 0) {
        // Dont push data
      } else {
        // Assign its value to the variable
        let receiverLeftReadyValue = receiverLeftReadySelectText;
        // Write to summary
        document
          .querySelector('.configurator_summary__list-receiver')
          .classList.remove('is-hidden');
        document.querySelector('.configurator_summary__list-receiver .value-left').innerHTML =
          receiverLeftReadyValue;
      }

      // Right
      // If select menu isnt first item
      if (receiverRightReadySelectIndex === 0) {
        // Dont push data
      } else {
        // Assign its value to the variable
        let receiverLeftReadyValue = receiverRightReadySelectText;
        // Write to summary
        document
          .querySelector('.configurator_summary__list-receiver')
          .classList.remove('is-hidden');
        document.querySelector('.configurator_summary__list-receiver .value-right').innerHTML =
          receiverLeftReadyValue;
      }

      // Interaction
      let receiverLeft = checkReceiver
        .closest('.configurator__accessories')
        .querySelector('product-dropdown .item_' + leftTranslation + ' .form-select__placeholder');
      let receiverLeftSelect = receiverLeftReadySelect?.options[0].innerText ?? '';

      let receiverRight = checkReceiver
        .closest('.configurator__accessories')
        .querySelector('product-dropdown .item_' + rightTranslation + ' .form-select__placeholder');
      let receiverRightSelect = receiverRightReadySelect?.options[0].innerText ?? '';

      // Interaction
      // If a user chooses a side item
      $(checkReceiver.closest('section')).on(
        'click',
        'product-dropdown .form-select__list-item, product-dropdown .number-input__button--plus, product-dropdown .number-input__button--minus',
        function () {
          if (
            this.closest('.configurator__accessories-content_item').getAttribute('data-item') ===
            leftTranslation
          ) {
            let hasLabel = this.querySelector('.form-select__list-label');
            // Assign its value to the variable
            // Check if it has a label or not
            if (typeof hasLabel != 'undefined' && hasLabel != null) {
              // check if value equals first item in Select menu e.g Select Left Side
              if (receiverLeftSelect === hasLabel.innerText) {
                leftValue = '';
              } else {
                leftValue = hasLabel.innerText;
              }
            } else {
              // check if value equals first item in Select menu e.g Select Left Side
              if (receiverLeftSelect === receiverLeft.innerText) {
                leftValue = '';
              } else {
                leftValue = receiverLeft.innerText;
              }
            }
            // Write to summary
            showSummary();
            document.querySelector('.configurator_summary__list-receiver .value-left').innerHTML =
              leftValue;
          } else if (
            this.closest('.configurator__accessories-content_item').getAttribute('data-item') ===
            rightTranslation
          ) {
            let hasLabel = this.querySelector('.form-select__list-label');
            // Assign its value to the variable
            // Check if it has a label or not
            if (typeof hasLabel != 'undefined' && hasLabel != null) {
              // check if value equals first item in Select menu e.g Select Right Side
              if (receiverRightSelect === hasLabel.innerText) {
                rightValue = '';
              } else {
                rightValue = hasLabel.innerText;
              }
            } else {
              // check if value equals first item in Select menu e.g Select Right Side
              if (receiverRightSelect === receiverRight.innerText) {
                rightValue = '';
              } else {
                rightValue = receiverRight.innerText;
              }
            }
            // Write to summary
            showSummary();
            document.querySelector('.configurator_summary__list-receiver .value-right').innerHTML =
              rightValue;
          }
        },
      );
    }
  } else {
    if (debugFunction) {
      console.log('%c Receiver ', consoleParentFalse);
    }
  }

  // ***************
  // Tubes
  // ***************
  let checkTubes = document.querySelector(
    '[id*="ConfigureAccessoriesTubes_ShowAccessories_AccessoriesPanel"]',
  );
  if (typeof checkTubes != 'undefined' && checkTubes != null) {
    if (debugFunction) {
      console.log('%c Tubes ', consoleParentTrue);
    }

    // Get the value for the sides as these can be translated but we need the values
    let sideTranslations = checkTubes
      .closest('.configurator__accessories')
      .querySelectorAll('.configurator__accessories-content_item');
    let leftTranslation =
      sideTranslations.length > 0 ? sideTranslations[0].getAttribute('data-item') : null;
    let rightTranslation =
      sideTranslations.length > 0 ? sideTranslations[1].getAttribute('data-item') : null;

    let tubesBundleCheck = checkTubes
      .closest('.configurator__accessories')
      .querySelectorAll('product-dropdown .number-input__field');
    let tubeAccessories = false;
    let tubesValue = [];
    let leftValue = [];
    let rightValue = [];

    // To show or hide summary section
    function showSummary() {
      if (
        leftValue.length >= 1 ||
        rightValue.length >= 1 ||
        tubesValue.length >= 1 ||
        tubeAccessories
      ) {
        document.querySelector('.configurator_summary__list-tube').classList.remove('is-hidden');
      } else {
        document.querySelector('.configurator_summary__list-tube').classList.add('is-hidden');
      }
    }

    function getAccessoriesData() {
      const accessoriesElements = Array.from(
        checkTubes
          .closest('.configurator__accessories')
          .querySelectorAll(
            '.configurator__accessories-list.accessories .configurator__accessories-item',
          ),
      );

      if (!accessoriesElements.length) {
        return '';
      }

      let wrapper = document.querySelector('.configurator_summary__list-tube .value-accessories');
      if (!wrapper) {
        wrapper = document.createElement('span');
        wrapper.classList.add('value-accessories');
        document.querySelector('.configurator_summary__list-tube .value').appendChild(wrapper);
      }

      const accessoriesTemplate = accessoriesElements.reduce((acc, curr) => {
        const title = curr.querySelector('.configurator__accessory-title')?.innerText;
        const isBundle = curr.querySelector(
          '.configurator__accessory-input .configurator__accessory-checkbox',
        );
        const field = isBundle
          ? isBundle
          : curr.querySelector('.configurator__accessory-input .number-input__field');

        if (isBundle && isBundle.checked) {
          return `<span>${title}</span>`;
        }

        if (!title || !Number(field?.value) || (isBundle && !isBundle?.checked)) {
          return acc;
        }

        return (acc += `<span>${Number(field?.value)} x ${title}</span>`);
      }, '');

      tubeAccessories = !!accessoriesTemplate.trim();
      wrapper.innerHTML = accessoriesTemplate;
    }

    // Check if bundled or unbundled
    // If the quantity have length we are bundled
    if (tubesBundleCheck.length > 0) {
      if (debugFunction) {
        console.log('%c Tubes Unbundled ', consoleChildTrue);
      }

      function getDataBoth(side) {
        // Find all items
        let items = checkTubes
          .closest('.configurator__accessories')
          .querySelectorAll('product-dropdown .item_' + side + ' .configurator__accessories-item');
        // Loop of them and push the text and quantity to the array
        items.forEach((item) => {
          let itemSelect = item.querySelector('.form-select select');
          let itemSelectIndex = itemSelect?.options[itemSelect.selectedIndex].index ?? 0;
          let itemSelectText = itemSelect?.options[itemSelect.selectedIndex].text ?? '';
          let itemValueQuantity = item.querySelector('.number-input__field')?.value;
          // If select menu isnt first item
          if (itemSelectIndex === 0) {
            // Dont push data
          } else {
            if (itemValueQuantity > 0) {
              if (side === leftTranslation) {
                leftValue.push([itemSelectText.split(',').join(', '), itemValueQuantity]);
              } else if (side === rightTranslation) {
                rightValue.push([itemSelectText.split(',').join(', '), itemValueQuantity]);
              }
            }
          }
        });
        let itemValueHTML = '';
        if (side === leftTranslation) {
          for (let item of leftValue) {
            itemValueHTML += `<span>${item[1]} x ${item[0]}</span>`;
          }
          // Write to summary
          document.querySelector('.configurator_summary__list-tube .value-left').innerHTML =
            itemValueHTML;
        } else if (side === rightTranslation) {
          for (let item of rightValue) {
            itemValueHTML += `<span>${item[1]} x ${item[0]}</span>`;
          }
          // Write to summary
          document.querySelector('.configurator_summary__list-tube .value-right').innerHTML =
            itemValueHTML;
        }
        showSummary();
      }

      // Page load
      getDataBoth(leftTranslation);
      getDataBoth(rightTranslation);
      getAccessoriesData();

      // Interaction
      // If a user chooses a side item
      $(checkTubes.closest('section')).on(
        'click',
        'product-dropdown .form-select__list-item, product-dropdown .number-input__button--plus, product-dropdown .number-input__button--minus',
        function () {
          getAccessoriesData();
          // Reset array so we dont need to search for duplicates
          leftValue = [];
          getDataBoth(leftTranslation);
          // Reset array so we dont need to search for duplicates
          rightValue = [];
          getDataBoth(rightTranslation);
        },
      );
      $(checkTubes.closest('section')).on('input', '.number-input__field', function () {
        getAccessoriesData();
        leftValue = [];
        getDataBoth(leftTranslation);
        rightValue = [];
        getDataBoth(rightTranslation);
      });
    } else {
      if (debugFunction) {
        console.log('%c Tubes Bundled ', consoleChildTrue);
      }
      function getData() {
        // There are two types of bundled Tubes with different HTML
        const bundleTypeA = () => {
          if (debugFunction) {
            console.log('%c Tubes Bundled Type A ', consoleChildTrue);
          }
          // Find all Tube containers
          let tubesAll = document.querySelectorAll(
            '[id*="ConfigureAccessoriesTubes_ShowAccessories_AccessoriesPanel"] .configurator__accessories-item',
          );
          // Loop of them and push the text and quantity to the array
          tubesAll.forEach((tube) => {
            let tubeValueText = tube.querySelector('.configurator__accessory-title').innerText;
            if (tube.querySelector('.number-input__field')) {
              if (debugFunction) {
                console.log('%c Tubes Bundled Type A ', consoleChildTrue);
              }
              let tubeValueQuantity = tube.querySelector('.number-input__field')
                ? tube.querySelector('.number-input__field').value
                : null;
              if (tubeValueQuantity > 0) {
                tubesValue.push([tubeValueText.split(',').join(', '), tubeValueQuantity]);
              }
              if (tube.querySelector('.number-input__field')) {
                tube.querySelector('.number-input__field').addEventListener('input', () => {
                  tubesValue = [];
                  getData();
                });
              }
            }
          });

          let tubeValueHTML = '';
          for (let tube of tubesValue) {
            tubeValueHTML += `<span>${tube[1]} x ${tube[0]}</span>`;
          }
          // Write to summary
          showSummary();
          document.querySelector('.configurator_summary__list-tube .value').innerHTML =
            tubeValueHTML;
        };

        const bundleTypeB = () => {
          if (debugFunction) {
            console.log('%c Tubes Bundled Type B ', consoleChildTrue);
          }
          if (
            checkTubes
              .closest('.configurator__accessories')
              .querySelector('product-dropdown .item_' + leftTranslation + ' select') ||
            checkTubes
              .closest('.configurator__accessories')
              .querySelector('product-dropdown .item_' + rightTranslation + ' select')
          ) {
            let tubeLeftReadySelect = checkTubes
              .closest('.configurator__accessories')
              .querySelector('product-dropdown .item_' + leftTranslation + ' select');
            let tubeLeftReadySelectIndex =
              tubeLeftReadySelect.options[tubeLeftReadySelect.selectedIndex].index;
            let tubeLeftReadySelectText =
              tubeLeftReadySelect.options[tubeLeftReadySelect.selectedIndex].text;

            let tubeRightReadySelect = checkTubes
              .closest('.configurator__accessories')
              .querySelector('product-dropdown .item_' + rightTranslation + ' select');
            let tubeRightReadySelectIndex =
              tubeRightReadySelect.options[tubeRightReadySelect.selectedIndex].index;
            let tubeRightReadySelectText =
              tubeRightReadySelect.options[tubeRightReadySelect.selectedIndex].text;

            // Left
            // If select menu isnt first item
            if (tubeLeftReadySelectIndex === 0) {
              // Dont push data
            } else {
              // Assign its value to the variable
              let tubeLeftReadyValue = tubeLeftReadySelectText;
              // Write to summary
              document
                .querySelector('.configurator_summary__list-tube')
                .classList.remove('is-hidden');
              document.querySelector('.configurator_summary__list-tube .value-left').innerHTML =
                tubeLeftReadyValue;
            }

            // Right
            // If select menu isnt first item
            if (tubeRightReadySelectIndex === 0) {
              // Dont push data
            } else {
              // Assign its value to the variable
              let tubeRightReadyValue = tubeRightReadySelectText;
              // Write to summary
              document
                .querySelector('.configurator_summary__list-tube')
                .classList.remove('is-hidden');
              document.querySelector('.configurator_summary__list-tube .value-right').innerHTML =
                tubeRightReadyValue;
            }

            // Interaction
            let tubeLeft = checkTubes
              .closest('.configurator__accessories')
              .querySelector(
                'product-dropdown .item_' + leftTranslation + ' .form-select__placeholder',
              );
            let tubeLeftSelect = tubeLeftReadySelect.options[0].innerText;

            let tubeRight = checkTubes
              .closest('.configurator__accessories')
              .querySelector(
                'product-dropdown .item_' + rightTranslation + ' .form-select__placeholder',
              );
            let tubeRightSelect = tubeRightReadySelect.options[0].innerText;

            // Interaction
            // If a user chooses a side item
            $(checkTubes.closest('section')).on(
              'click',
              'product-dropdown .form-select__list-item, product-dropdown .number-input__button--plus, product-dropdown .number-input__button--minus',
              function () {
                if (
                  this.closest('.configurator__accessories-content_item').getAttribute(
                    'data-item',
                  ) === leftTranslation
                ) {
                  let hasLabel = this.querySelector('.form-select__list-label');
                  // Assign its value to the variable
                  // Check if it has a label or not
                  if (typeof hasLabel != 'undefined' && hasLabel != null) {
                    // check if value equals first item in Select menu e.g Select Left Side
                    if (tubeLeftSelect === hasLabel.innerText) {
                      leftValue = '';
                    } else {
                      leftValue = hasLabel.innerText;
                    }
                  } else {
                    // check if value equals first item in Select menu e.g Select Left Side
                    if (tubeLeftSelect === tubeLeft.innerText) {
                      leftValue = '';
                    } else {
                      leftValue = tubeLeft.innerText;
                    }
                  }
                  // Write to summary
                  showSummary();
                  document.querySelector('.configurator_summary__list-tube .value-left').innerHTML =
                    leftValue;
                } else if (
                  this.closest('.configurator__accessories-content_item').getAttribute(
                    'data-item',
                  ) === rightTranslation
                ) {
                  let hasLabel = this.querySelector('.form-select__list-label');
                  // Assign its value to the variable
                  // Check if it has a label or not
                  if (typeof hasLabel != 'undefined' && hasLabel != null) {
                    // check if value equals first item in Select menu e.g Select Right Side
                    if (tubeRightSelect === hasLabel.innerText) {
                      rightValue = '';
                    } else {
                      rightValue = hasLabel.innerText;
                    }
                  } else {
                    // check if value equals first item in Select menu e.g Select Right Side
                    if (tubeRightSelect === receiverRight.innerText) {
                      rightValue = '';
                    } else {
                      rightValue = tubeRight.innerText;
                    }
                  }
                  // Write to summary
                  showSummary();
                  document.querySelector(
                    '.configurator_summary__list-tube .value-right',
                  ).innerHTML = rightValue;
                }
              },
            );
          }
        };

        // Bundled Type A
        let tubesTypeCheck = document.querySelectorAll(
          '[id*="ConfigureAccessoriesTubes_ShowAccessories_AccessoriesPanel"] .configurator__accessories-item .number-input__field',
        );
        if (tubesTypeCheck.length > 0) {
          bundleTypeA();
        } else {
          bundleTypeB();
        }
      }

      // Page load
      getData();
      getAccessoriesData();
      // Interaction
      $(document).on(
        'click',
        '[id*="ConfigureAccessoriesTubes_ShowAccessories_AccessoriesPanel"] .number-input__button--minus, [id*="ConfigureAccessoriesTubes_ShowAccessories_AccessoriesPanel"] .number-input__button--plus',
        function () {
          getAccessoriesData();
          // Reset array so we dont need to search for duplicates
          tubesValue = [];
          getData();
        },
      );
    }
  } else {
    if (debugFunction) {
      console.log('%c Tubes ', consoleParentFalse);
    }
  }

  // ***************
  // Dome
  // ***************
  let checkDome = document.querySelector(
    '[id*="ConfigureAccessoriesDomes_ShowAccessories_AccessoriesPanel"]',
  );
  if (typeof checkDome != 'undefined' && checkDome != null) {
    if (debugFunction) {
      console.log('%c Dome ', consoleParentTrue);
    }

    let value = [];

    // To show or hide summary section
    function showSummary() {
      if (value.length >= 1) {
        document.querySelector('.configurator_summary__list-dome').classList.remove('is-hidden');
      } else {
        document.querySelector('.configurator_summary__list-dome').classList.add('is-hidden');
      }
    }

    let domeBundleCheck = checkDome
      .closest('.configurator__accessories')
      .querySelectorAll('product-dropdown .number-input__field');
    // Check if bundled or unbundled
    // If the quantity have length we are bundled
    if (domeBundleCheck.length > 0) {
      if (debugFunction) {
        console.log('%c Dome Unbundled ', consoleChildTrue);
      }

      function getData() {
        // Find all items
        let items = checkDome
          .closest('.configurator__accessories')
          .querySelectorAll('product-dropdown .configurator__accessories-item');
        // Loop of them and push the text and quantity to the array
        items.forEach((item) => {
          let itemSelect = item.querySelector('.form-select select');
          let itemSelectIndex = itemSelect.options[itemSelect.selectedIndex].index;
          let itemSelectText = itemSelect.options[itemSelect.selectedIndex].text;
          let itemValueQuantity = item.querySelector('.number-input__field').value;
          // If select menu isnt first item
          if (itemSelectIndex === 0) {
            // Dont push data
          } else {
            if (itemValueQuantity > 0) {
              value.push([itemSelectText.split(',').join(', '), itemValueQuantity]);
            }
          }
        });
        let itemValueHTML = '';
        for (let item of value) {
          itemValueHTML += `<span>${item[1]} x ${item[0]}</span>`;
        }
        // Write to summary
        showSummary();
        document.querySelector('.configurator_summary__list-dome .value').innerHTML = itemValueHTML;
      }

      // Page load
      getData();

      // Interaction
      $(checkDome.closest('section')).on(
        'click',
        'product-dropdown .form-select__list-item, product-dropdown .number-input__button--plus, product-dropdown .number-input__button--minus',
        function () {
          // Reset array so we dont need to search for duplicates
          value = [];
          getData();
        },
      );

      $(checkDome.closest('section')).on('input', '.number-input__field', function () {
        value = [];
        getData();
      });
    } else {
      if (debugFunction) {
        console.log('%c Dome Bundled ', consoleChildTrue);
      }
      // On page we load we have different html we need to run the IF = select side against
      // Once we click on Stock or Color we are passed different HTML but we still need to run the same if against it
      // on page load if html has more html with nested span assign that inner text to var, else target default html and assign that innertext to var
      // Basically the check is are we seeing just '.form-select__placeholder' or '.form-select__placeholder > .form-select__list-label'

      // Page load
      let dropdownSelect = checkDome
        .closest('.configurator__accessories')
        .querySelector('product-dropdown .configurator__accessories-content_item select');
      let dropdownSelectIndex = dropdownSelect?.options[dropdownSelect.selectedIndex].index ?? 0;
      let dropdownSelectText = dropdownSelect?.options[dropdownSelect.selectedIndex].text ?? '';

      // Left
      // If select menu isnt first item
      if (dropdownSelectIndex === 0) {
        // Dont push data
      } else {
        // Assign its value to the variable
        let dropdownSelectValue = dropdownSelectText;
        // Write to summary
        document.querySelector('.configurator_summary__list-dome').classList.remove('is-hidden');
        document.querySelector('.configurator_summary__list-dome .value').innerHTML =
          dropdownSelectValue;
      }

      // Interaction
      let dropdownPlaceholder = checkDome
        .closest('.configurator__accessories')
        .querySelector(
          'product-dropdown .configurator__accessories-content_item .form-select__placeholder',
        );
      let dropdownPlaceholderSelect = dropdownSelect?.options[0].innerText ?? '';

      // Interaction
      // If a user chooses a side item
      $(checkDome.closest('section')).on(
        'click',
        'product-dropdown .form-select__list-item, product-dropdown .number-input__button--plus, product-dropdown .number-input__button--minus',
        function () {
          let hasLabel = this.querySelector('.form-select__list-label');
          // Assign its value to the variable
          // Check if it has a label or not
          if (typeof hasLabel != 'undefined' && hasLabel != null) {
            // check if value equals first item in Select menu e.g Select Left Side
            if (dropdownPlaceholderSelect === hasLabel.innerText) {
              value = '';
            } else {
              value = hasLabel.innerText;
            }
          } else {
            // check if value equals first item in Select menu e.g Select Left Side
            if (dropdownPlaceholderSelect === dropdownPlaceholder.innerText) {
              value = '';
            } else {
              value = dropdownPlaceholder.innerText;
            }
          }
          // Write to summary
          showSummary();
          document.querySelector('.configurator_summary__list-dome .value').innerHTML = value;
        },
      );
    }
  } else {
    if (debugFunction) {
      console.log('%c Dome ', consoleParentFalse);
    }
  }

  // ***************
  // Warranty
  // ***************
  let checkWarranty = document.querySelector('#configure_warranty');
  if (typeof checkWarranty != 'undefined' && checkWarranty != null) {
    if (debugFunction) {
      console.log('%c Warranty ', consoleParentTrue);
    }
    // Pageload
    let warranty = document.querySelector('select[id*="ConfigureWarranty"]');
    let warrantyValue = '';

    // To show or hide summary section
    function showSummary() {
      if (warranty.options[warranty.selectedIndex].index === 0) {
        document.querySelector('.configurator_summary__list-warranty').classList.add('is-hidden');
      } else {
        document
          .querySelector('.configurator_summary__list-warranty')
          .classList.remove('is-hidden');
      }
    }

    // If the question exists and has a value
    if (typeof warranty != 'undefined' && warranty != null) {
      // Assign its value to the variable
      warrantyValue = warranty.options[warranty.selectedIndex].text;
      // Write to summary
      showSummary();
      document.querySelector('.configurator_summary__list-warranty .value').innerHTML =
        warrantyValue;

      // Interaction
      // If user chooses a warranty
      warranty.addEventListener('change', () => {
        // Assign its value to the variable
        warrantyValue = warranty.options[warranty.selectedIndex].text;
        // Write to summary
        showSummary();
        document.querySelector('.configurator_summary__list-warranty .value').innerHTML =
          warrantyValue;
      });
    }
  } else {
    if (debugFunction) {
      console.log('%c Warranty ', consoleParentFalse);
    }
  }

  // ***************
  // Wireless Accessories
  // ***************
  let checkWirelessAccessories = document.querySelector('accessories-carousel');
  if (typeof checkWirelessAccessories != 'undefined' && checkWirelessAccessories != null) {
    if (debugFunction) {
      console.log('%c Wireless Accessories ', consoleParentTrue);
    }

    let value = [];

    // To show or hide summary section
    function showSummary() {
      if (value.length >= 1) {
        document
          .querySelector('.configurator_summary__list-wireless-accessories')
          .classList.remove('is-hidden');
      } else {
        document
          .querySelector('.configurator_summary__list-wireless-accessories')
          .classList.add('is-hidden');
      }
    }

    function getData() {
      let wirelessAccessories = document.querySelectorAll('accessories-carousel');

      wirelessAccessories.forEach((slide) => {
        let accessoryItems = slide.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');

        accessoryItems.forEach((item) => {
          let accessoryItemQuantity = item.querySelector('.number-input__field').value;
          let accessoryItemText = item.querySelector('.configurator__accessory-title').innerText;

          // If quantity above 0
          if (accessoryItemQuantity > 0) {
            value.push([accessoryItemText.split(',').join(', '), accessoryItemQuantity]);
          }

          let itemValueHTML = '';
          for (let item of value) {
            itemValueHTML += `<span>${item[1]} x ${item[0]}</span>`;
          }
          // Write to summary
          showSummary();
          document.querySelector(
            '.configurator_summary__list-wireless-accessories .value',
          ).innerHTML = itemValueHTML;
        });
      });
    }

    // Page load
    getData();

    // Interaction
    $(document).on(
      'click',
      'accessories-carousel .number-input__button--plus, accessories-carousel .number-input__button--minus',
      function () {
        // Reset array so we dont need to search for duplicates
        value = [];
        getData();
      },
    );

    $(document).on('input', 'accessories-carousel .number-input__field', function () {
      setTimeout(() => {
        value = [];
        getData();
      }, 1000);
    });
  } else {
    if (debugFunction) {
      console.log('%c Wireless Accessories ', consoleParentFalse);
    }
  }

  // ***************
  // Pediatrics
  // ***************
  let checkPediatrics = document.querySelector('[id*="PediatricFittingPanel"]');
  if (typeof checkPediatrics != 'undefined' && checkPediatrics != null) {
    if (debugFunction) {
      console.log('%c Pediatrics ', consoleParentTrue);
    }

    let checkbox = checkPediatrics;
    let checkboxInput = checkPediatrics.querySelector('input');

    // Page load
    if (checkboxInput.checked) {
      // Show
      document
        .querySelector('.configurator_summary__list-pediatrics')
        .classList.remove('is-hidden');
      document
        .querySelector('.configurator_summary__list-pediatrics .value')
        .classList.remove('is-hidden');
    } else {
      // Hide
      document.querySelector('.configurator_summary__list-pediatrics').classList.add('is-hidden');
      document
        .querySelector('.configurator_summary__list-pediatrics .value')
        .classList.add('is-hidden');
    }

    // Interaction
    checkbox.querySelector('label').addEventListener('click', () => {
      checkbox.addEventListener('change', () => {
        if (checkboxInput.checked) {
          // Show
          document
            .querySelector('.configurator_summary__list-pediatrics')
            .classList.remove('is-hidden');
          document
            .querySelector('.configurator_summary__list-pediatrics .value')
            .classList.remove('is-hidden');
        } else {
          // Hide
          document
            .querySelector('.configurator_summary__list-pediatrics')
            .classList.add('is-hidden');
          document
            .querySelector('.configurator_summary__list-pediatrics .value')
            .classList.add('is-hidden');
        }
      });
    });
  } else {
    if (debugFunction) {
      console.log('%c Pediatrics ', consoleParentFalse);
    }
  }

  // ***************
  // Bimodal
  // ***************
  let checkBimodal = document.querySelector('[id*="BimodalFittingPanel"]');
  if (typeof checkBimodal != 'undefined' && checkBimodal != null) {
    if (debugFunction) {
      console.log('%c Bimodal ', consoleParentTrue);
    }

    let checkbox = checkBimodal;
    let checkboxInput = checkBimodal.querySelector('input');

    // Page load
    if (checkboxInput.checked) {
      // Show
      document.querySelector('.configurator_summary__list-bimodal').classList.remove('is-hidden');
      document
        .querySelector('.configurator_summary__list-bimodal .value')
        .classList.remove('is-hidden');
    } else {
      // Hide
      document.querySelector('.configurator_summary__list-bimodal').classList.add('is-hidden');
      document
        .querySelector('.configurator_summary__list-bimodal .value')
        .classList.add('is-hidden');
    }

    // Interaction
    checkbox.querySelector('label').addEventListener('click', () => {
      checkbox.addEventListener('change', () => {
        if (checkboxInput.checked) {
          // Show
          document
            .querySelector('.configurator_summary__list-bimodal')
            .classList.remove('is-hidden');
          document
            .querySelector('.configurator_summary__list-bimodal .value')
            .classList.remove('is-hidden');
        } else {
          // Hide
          document.querySelector('.configurator_summary__list-bimodal').classList.add('is-hidden');
          document
            .querySelector('.configurator_summary__list-bimodal .value')
            .classList.add('is-hidden');
        }
      });
    });
  } else {
    if (debugFunction) {
      console.log('%c Bimodal ', consoleParentFalse);
    }
  }

  // ***************
  // MetalEarHooks
  // ***************
  let checkMetalHook = document.querySelector(
    '[id*="ConfigureAccessoriesMetalEarHooks_ShowAccessories_AccessoriesPanel"]',
  );
  if (typeof checkMetalHook != 'undefined' && checkMetalHook != null) {
    if (debugFunction) {
      console.log('%c MetalHook ', consoleParentTrue);
    }

    let value = [];

    // To show or hide summary section
    function showSummary() {
      if (value.length >= 1) {
        document
          .querySelector('.configurator_summary__list-metalearhook')
          .classList.remove('is-hidden');
      } else {
        document
          .querySelector('.configurator_summary__list-metalearhook')
          .classList.add('is-hidden');
      }
    }

    //let domeBundleCheck = checkDome.closest('.configurator__accessories').querySelectorAll('product-dropdown .number-input__field');
    let metalHookBundleCheck = checkMetalHook
      .closest('.configurator__accessories')
      .querySelectorAll('product-dropdown .number-input__field');
    // Check if bundled or unbundled
    // If the quantity have length we are bundled
    if (metalHookBundleCheck.length > 0) {
      if (debugFunction) {
        console.log('%c MetalHook Unbundled ', consoleChildTrue);
      }

      function getData() {
        // Find all items
        let items = checkMetalHook
          .closest('.configurator__accessories')
          .querySelectorAll('product-dropdown .configurator__accessories-item');
        // Loop of them and push the text and quantity to the array
        items.forEach((item) => {
          let itemSelect = item.querySelector('.form-select select');
          let itemSelectIndex = itemSelect.options[itemSelect.selectedIndex].index;
          let itemSelectText = itemSelect.options[itemSelect.selectedIndex].text;
          let itemValueQuantity = item.querySelector('.number-input__field').value;
          // If select menu isnt first item
          if (itemSelectIndex === 0) {
            // Dont push data
          } else {
            if (itemValueQuantity > 0) {
              value.push([itemSelectText.split(',').join(', '), itemValueQuantity]);
            }
          }
        });
        let itemValueHTML = '';
        for (let item of value) {
          itemValueHTML += `<span>${item[1]} x ${item[0]}</span>`;
        }
        // Write to summary
        showSummary();
        document.querySelector('.configurator_summary__list-metalearhook .value').innerHTML =
          itemValueHTML;
      }

      // Page load
      getData();

      // Interaction
      $(checkMetalHook.closest('section')).on(
        'click',
        'product-dropdown .form-select__list-item, product-dropdown .number-input__button--plus, product-dropdown .number-input__button--minus',
        function () {
          // Reset array so we dont need to search for duplicates
          value = [];
          getData();
        },
      );

      $(checkMetalHook.closest('section')).on('input', '.number-input__field', function () {
        value = [];
        getData();
      });
    } else {
      if (debugFunction) {
        console.log('%c MeatalHook Bundled ', consoleChildTrue);
      }
      // On page we load we have different html we need to run the IF = select side against
      // Once we click on Stock or Color we are passed different HTML but we still need to run the same if against it
      // on page load if html has more html with nested span assign that inner text to var, else target default html and assign that innertext to var
      // Basically the check is are we seeing just '.form-select__placeholder' or '.form-select__placeholder > .form-select__list-label'

      // Page load
      /* eslint-disable-next-line */
      let dropdownSelect = checkMetalHook
        .closest('.configurator__accessories')
        .querySelector('product-dropdown .configurator__accessories-content_item select');
      /*
            let dropdownSelectIndex = dropdownSelect.options[dropdownSelect.selectedIndex].index;
            let dropdownSelectText = dropdownSelect.options[dropdownSelect.selectedIndex].text;

            
            // Left
            // If select menu isnt first item
            if (dropdownSelectIndex === 0) {
                // Dont push data
            } else {
                // Assign its value to the variable
                let dropdownSelectValue = dropdownSelectText;
                // Write to summary
                document.querySelector('.configurator_summary__list-metalearhook').classList.remove('is-hidden');
                document.querySelector('.configurator_summary__list-metalearhook .value').innerHTML = dropdownSelectValue;
            }
            
            // Interaction
            let dropdownPlaceholder = checkMetalHook.closest('.configurator__accessories').querySelector('product-dropdown .configurator__accessories-content_item .form-select__placeholder');
            let dropdownPlaceholderSelect = dropdownSelect.options[0].innerText;
         

            // Interaction
            // If a user chooses a side item
            $(checkMetalHook.closest('section')).on('click', 'product-dropdown .form-select__list-item, product-dropdown .number-input__button--plus, product-dropdown .number-input__button--minus', function () {
                let hasLabel = this.querySelector('.form-select__list-label');
                // Assign its value to the variable
                // Check if it has a label or not
                if (typeof (hasLabel) != 'undefined' && hasLabel != null) {
                    // check if value equals first item in Select menu e.g Select Left Side
                    if (dropdownPlaceholderSelect === hasLabel.innerText) {
                        value = '';
                    } else {
                        value = hasLabel.innerText;
                    }
                } else {
                    // check if value equals first item in Select menu e.g Select Left Side
                    if (dropdownPlaceholderSelect === dropdownPlaceholder.innerText) {
                        value = '';
                    } else {
                        value = dropdownPlaceholder.innerText;
                    }
                }
                // Write to summary
                showSummary();
                document.querySelector('.configurator_summary__list-metalearhook .value').innerHTML = value;
            })
            */
    }

    // ***************
    // DOM ready
    // ***************
    $(document).ready(function () {
      // ***************
      // Sanitize all inputs
      // ***************
      $('.configurator_controllers input.form-control').each(function () {
        const input = $(this);
        input.on('change', () => input.val(DOMSanitization.sanitize(input.val())));
      });
    });
  } else {
    if (debugFunction) {
      console.log('%c MetalHook ', consoleParentFalse);
    }
  }
}
